import { AI_RECOMPOSE_MODE, GENERATION_SOURCE_TYPE } from 'src/data/generation';
import {
  doesToolSupportEnhancedImprovements,
  GENERATION_TOOL,
  getToolDescription,
  getToolGeneratingLoaderText,
  getToolTitle,
  isBasicContentImproverTool,
  isFreestyleGenerationTool,
  isRewriteGenerationTool,
} from 'src/data/generationTool';

const formatLoaderTitle = ({
  sourceType,
  recomposeMode,
  generationTool,
  originalVariationId,
  manualInstructions,
  sections,
  onlyImproveScore,
}) => {
  if (isImproveScore({ generationTool, originalVariationId, manualInstructions })) {
    return {
      title: 'Boosting',
      tail: 'Performance',
      showDescription: true,
    };
  }

  if (sourceType === GENERATION_SOURCE_TYPE.improveListScore) {
    return {
      title: 'Improving score',
      showDescription: true,
    };
  }

  if (generationTool === GENERATION_TOOL.summarizer) {
    return {
      title: 'Summarizing',
    };
  }

  const isSectionsRewrite = sections != null;
  const isRewriteTool =
    isRewriteGenerationTool(generationTool) ||
    isBasicContentImproverTool(generationTool) ||
    isSectionsRewrite;
  if (isRewriteTool && recomposeMode === AI_RECOMPOSE_MODE.formatGroups) {
    return {
      title: 'Applying AP Style Guide. This can take a few minutes.',
    };
  }

  // if this is "improve short-form sections" flow
  if (isSectionsRewrite) {
    return {
      title: 'Improving',
      tail: onlyImproveScore ? 'Performance' : '',
      showDescription: true,
    };
  }

  if (isBasicContentImproverTool(generationTool)) {
    return {
      title: 'Improving content',
    };
  }

  return {
    title: 'Generating',
    showDescription: true,
  };
};

const formatDescription = ({ generationTool, title, description, skipGetTextByTool }) => {
  const toolTitle = title || getToolTitle(generationTool);
  const toolDescription = description || getToolDescription(generationTool);

  if (isFreestyleGenerationTool(generationTool)) {
    return ``;
  }

  const loaderText = skipGetTextByTool ? '' : getToolGeneratingLoaderText(generationTool);

  if (loaderText) {
    return loaderText;
  }

  return `${toolTitle}${toolDescription ? ` - ${toolDescription}` : ''}`;
};

const isImproveScore = ({ generationTool, originalVariationId, manualInstructions }) => {
  if (!doesToolSupportEnhancedImprovements(generationTool)) {
    return false;
  }

  if (!originalVariationId) {
    return false;
  }

  return !manualInstructions;
};

export const getGenerationLoaderContent = (params) => {
  const { title, showDescription, tail } = formatLoaderTitle(params);
  const description = showDescription ? formatDescription(params) : null;

  return {
    title,
    description,
    tail,
  };
};
